import { BaseSubtypeDataModel } from "../instance/subtypeData";
import { BaseModuleSubtype } from "./subtype";

export interface ChecklistAnswerSubtypeResponse extends BaseModuleSubtype {
    positiveAnswerText: string | null;
    negativeAnswerText: string | null;
    completionDescriptionText: string | null;
    checklistItems: ChecklistAnswerItem[];
    checklistAnswerType: ChecklistAnswerType;
};

export interface ChecklistAnswerItem {
    id?: number;
    text: string;
    positiveCheckedReward: number;
    negativeCheckedReward: number;
    notCheckedReward: number;
}

export function isChecklistAnswerItem(obj: any): obj is ChecklistAnswerItem {
    return typeof obj === 'object' && obj !== null &&
        (typeof obj.id === 'number' || typeof obj.id === 'undefined') &&
        typeof obj.text === 'string' &&
        typeof obj.positiveCheckedReward === 'number' &&
        typeof obj.negativeCheckedReward === 'number' &&
        typeof obj.notCheckedReward === 'number';
}

export function isChecklistAnswerItemArray(obj: any): obj is ChecklistAnswerItem[] {
    return Array.isArray(obj) && obj.every(isChecklistAnswerItem);
}

export interface ChecklistAnswerSubtypeDataModel extends BaseSubtypeDataModel {
    answers: { [key: number]: ChecklistItemAnswers };
}

export type ChecklistItemAnswers = "CheckedPositive" | "CheckedNegative" | "NotChecked";
export type ChecklistAnswerType = "SingleChoice" | "MultipleChoice" | "MultipleChoiceWithDecline";